
import { PatientNoteContent } from "../../../api/types"

interface PatientNoteProps {
  patientNote: PatientNoteContent
}

export default function PatientNote({ patientNote }: PatientNoteProps) {
  return (
    <div className="space-y-6 mb-8">
      <div>
        <h2 className="text-sm font-medium text-[#202020CC]">Subjective: <span className="mt-1 font-normal text-[#202020CC]">{patientNote.subjective}</span></h2>
      </div>

      <div>
        <h2 className="text-sm font-medium text-[#202020CC]">Objective: <span className="mt-1 font-normal text-[#202020CC]">{patientNote.objective || ""}</span></h2>
      </div>

      <div>
        <h2 className="text-sm font-medium text-[#202020CC]">Assessment: <span className="mt-1 font-normal text-[#202020CC]">{patientNote.assessment}</span></h2>
      </div>

      <div>
        <h2 className="text-sm font-medium text-[#202020CC]">Plan: <span className="mt-1 font-normal text-[#202020CC]">{patientNote.plan || ""}</span></h2>
      </div>
    </div>
  )
}